import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "relative" }

import {
  Combobox,
  ComboboxButton,
  ComboboxInput,
  ComboboxOption,
  ComboboxOptions,
  ComboboxLabel,
} from "@headlessui/vue";
import { ChevronUpDownIcon } from "@heroicons/vue/24/outline";
import { ref, PropType, computed, onMounted } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'OaiCombobox',
  props: /*#__PURE__*/_mergeModels({
  options: {
    type: Array as PropType<{ value: unknown; name: string }[]>,
    required: true,
  },
  selected: {
    type: [String, Array] as unknown as PropType<string>,
    default: "",
  },
  multiple: {
    type: Boolean,
    default: false,
  },
  label: {
    type: String,
  },
  placeholder: {
    type: String,
  },
  readonly: {
    type: Boolean,
    default: false,
  },
  minWidth: {
    type: Number,
    required: false,
    default: 180,
  },
  inputFieldClass: {
    type: String,
    default:
      "w-full rounded-md border-0 bg-white py-1.5 pl-3 pr-10 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-orange-300 sm:text-sm sm:leading-6",
  },
}, {
    "modelValue": { type: [String, Number, Boolean, Object, null, Array] },
    "modelModifiers": {},
  }),
  emits: /*#__PURE__*/_mergeModels(["update:selected"], ["update:modelValue"]),
  setup(__props, { emit: __emit }) {

const props = __props;

const emits = __emit;
const query = ref("");

const model = _useModel<
  | string
  | number
  | boolean
  | object
  | null
  | undefined
  | (string | number | boolean | object | null | undefined)[]
>(__props, "modelValue");

onMounted(() => {
  if (props.selected) {
    model.value = props.selected;
  }
});

const filteredOptions = computed(() =>
  query.value
    ? props.options.filter((option) =>
        option.name.toLowerCase().includes(query.value.toLowerCase()),
      )
    : props.options,
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Combobox), {
    as: "div",
    modelValue: model.value,
    "onUpdate:modelValue": [
      _cache[1] || (_cache[1] = ($event: any) => ((model).value = $event)),
      _cache[2] || (_cache[2] = ($event: any) => (emits('update:selected', $event)))
    ],
    style: _normalizeStyle({ minWidth: `${__props.minWidth}px` }),
    disabled: __props.readonly,
    multiple: __props.multiple
  }, {
    default: _withCtx(() => [
      (__props.label)
        ? (_openBlock(), _createBlock(_unref(ComboboxLabel), {
            key: 0,
            class: "text-sm"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(__props.label), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_unref(ComboboxInput), {
          class: _normalizeClass([__props.inputFieldClass, __props.readonly ? 'bg-gray-50 cursor-default' : 'bg-white']),
          onChange: _cache[0] || (_cache[0] = ($event: any) => (query.value = $event.target.value)),
          autocomplete: "one-time-code",
          displayValue: (value) => __props.options.find((option) => option.value === value)?.name as string || query.value,
          placeholder: __props.placeholder
        }, null, 8, ["class", "displayValue", "placeholder"]),
        _createVNode(_unref(ComboboxButton), { class: "absolute inset-y-0 right-0 flex items-center rounded-r-md px-2 focus:outline-none" }, {
          default: _withCtx(() => [
            _createVNode(_unref(ChevronUpDownIcon), {
              class: "h-5 w-5 text-gray-400",
              "aria-hidden": "true"
            })
          ]),
          _: 1
        }),
        (filteredOptions.value.length > 0)
          ? (_openBlock(), _createBlock(_unref(ComboboxOptions), {
              key: 0,
              class: "absolute z-50 mt-1 max-h-60 overflow-auto rounded-md bg-white py-1 text-xs shadow-lg ring-1 ring-yellow-500/5 focus:outline-none sm:text-sm w-full"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredOptions.value, (option) => {
                  return (_openBlock(), _createBlock(_unref(ComboboxOption), {
                    key: option.value as string,
                    value: option.value as string,
                    as: "template"
                  }, {
                    default: _withCtx(({ active, selected }) => [
                      _createElementVNode("li", {
                        class: _normalizeClass([
              (active || selected) && 'bg-yellow-100',
              'relative cursor-pointer select-none py-2 pl-3 pr-9 text-gray-900',
            ])
                      }, [
                        _createElementVNode("span", {
                          class: _normalizeClass(['block truncate', selected && 'font-semibold'])
                        }, _toDisplayString(option.name), 3)
                      ], 2)
                    ]),
                    _: 2
                  }, 1032, ["value"]))
                }), 128))
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "style", "disabled", "multiple"]))
}
}

})